import AuditLogList from './AuditLogList';

export default {
  list: AuditLogList,
};
